import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-ico",
  "use": "icon-close-ico-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8 8\" id=\"icon-close-ico\">\r\n<style type=\"text/css\">\r\n\t#icon-close-ico .st0{fill:#888888;}\r\n</style>\r\n<path class=\"st0\" d=\"M8,0.9L7.1,0L4,3.1L0.9,0L0,0.9L3.1,4L0,7.1L0.9,8L4,4.9L7.1,8L8,7.1L4.9,4L8,0.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol